// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { ThemeManager } from './utils/theme';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css';
// 导入懒加载库
import lazyPlugin from 'vue3-lazy'
import pinia from '@/store/index.js';
import { normalizePlatform } from '@/config/tabConfig';
import '@/assets/font/iconfont-showhide.css';
import { useUserStore } from '@/store/modules/userStore';
// import 'lib-flexible'
import 'bootstrap/dist/css/bootstrap.min.css'
import * as Popper from '@popperjs/core'
import './assets/css/base.scss'
// Bootstrap JS 已通过 CDN 在 index.html 中加载，此处不再重复加载
window.Popper = Popper

// 初始化全局收藏缓存（使用Map保证键值对唯一性）
if (!window.favoriteCache) {
  window.favoriteCache = new Map();
}
const initFavoriteCache = () => {
  try {
    // 尝试加载 favoriteProducts 格式（favoriteManager 保存的格式）
    const favProductsStr = localStorage.getItem('favoriteProducts');
    if (favProductsStr) {
      try {
        const favProductsObj = JSON.parse(favProductsStr);
        // favoriteProducts 格式: { "skuId_platform": { isFavorite: true, ... } }
        Object.entries(favProductsObj).forEach(([key, value]) => {
          if (value?.isFavorite) {
            window.favoriteCache.set(key, true);
          }
        });
        console.log('[initFavoriteCache] 从 favoriteProducts 加载', window.favoriteCache.size, '条');
      } catch (e) {
        console.warn('[initFavoriteCache] 解析 favoriteProducts 失败');
      }
    }
    
    // 同时加载 favoriteCache 格式（直接布尔值格式）
    const cacheStr = localStorage.getItem('favoriteCache');
    if (cacheStr) {
      const cacheObj = JSON.parse(cacheStr);
      Object.entries(cacheObj).forEach(([key, value]) => {
        if (!(value === true || value === 'true')) return;
        const lastIdx = key.lastIndexOf('_');
        if (lastIdx > 0) {
          const skuId = key.slice(0, lastIdx);
          const platform = key.slice(lastIdx + 1);
          const normalizedKey = `${skuId}_${normalizePlatform(platform)}`;
          window.favoriteCache.set(normalizedKey, true);
        } else {
          window.favoriteCache.set(key, true);
        }
      });
      console.log('[initFavoriteCache] 从 favoriteCache 加载后共', window.favoriteCache.size, '条');
    }
  } catch (e) {
    console.error('初始化收藏缓存失败：', e);
    window.favoriteCache.clear();
    localStorage.removeItem('favoriteCache');
  }
};

// 创建手动同步方法，替代 Proxy
window.syncFavoriteCacheToLocal = () => {
  try {
    const cacheObj = Object.fromEntries(window.favoriteCache);
    localStorage.setItem('favoriteCache', JSON.stringify(cacheObj));
  } catch (e) {
    console.error('同步收藏缓存到本地失败：', e);
  }
};

// 初始化缓存
initFavoriteCache();

ThemeManager.init();

const app = createApp(App)

app.use(ElementPlus, {
  locale: zhCn
})
app.use(router)
app.use(pinia);

// 初始化用户登录状态（保证非受保护页面也能拿到登录态与收藏缓存）
try {
  const userStore = useUserStore(pinia);
  userStore.initUserStatus();
} catch (e) {
  console.warn('初始化用户状态失败：', e && e.message);
}
// 注册懒加载指令，配置占位图
app.use(lazyPlugin, {
  // 加载中的占位图（可替换为项目内的图片）
  loading: 'https://picsum.photos/seed/loading/300/300',
  // 加载失败的占位图（可替换为项目内的图片）
  error: 'https://picsum.photos/seed/error/300/300',
  // 懒加载的触发距离（默认200px）
  preLoad: 200
})
app.mount('#app')
